import React from 'react';
import { getBalanceTotalExpectedPrice, getBalanceTotalMaximumPrice } from '../../../balanceUtils';
import { IBalanceInstruction } from '../../../../../sp-types/balanceFlowType';

interface BFDealCharacteristicsProps {
  data: { title: string; text: string; icon: string }[];
}

const BFDealCharacteristics: React.FC<BFDealCharacteristicsProps> = ({ data }) => {
  return (
    <div className="space-y-4 flex-1">
      <h6 className="text-red m-0">Deal characteristics</h6>
      <div className="flex flex-row space-x-3 justify-between">
        {data.map((item, index) => (
          <div key={index} className="space-y-2">
            <p className="text-sm text-gray-450">{item.title}</p>
            <div className="flex space-x-2">
              <img src={item.icon}></img>
              <p className="">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

interface DCProps {
  balanceInstructions: IBalanceInstruction[];
}

export const ExecutionDealCharacteristics: React.FC<DCProps> = ({ balanceInstructions }) => {
  return (
    <BFDealCharacteristics
      data={[
        { title: 'Deal type', text: 'Monitored', icon: '../assets/icons/gray-bg/support.svg' },
        {
          title: 'Total expected price',
          text: '$' + getBalanceTotalExpectedPrice(balanceInstructions).toLocaleString(),
          icon: '../assets/icons/gray-bg/price-tag.svg',
        },
        {
          title: 'Total maximum price',
          text: '$' + getBalanceTotalMaximumPrice(balanceInstructions).toLocaleString(),
          icon: '../assets/icons/gray-bg/price-tag.svg',
        },
      ]}
    />
  );
};
